import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Search, ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';
interface BrandSelectionStepProps {
  onNext: (data: any) => void;
  onBack: () => void;
}
const brands = [{
  id: 'ann-taylor',
  name: 'Ann Taylor Petite',
  items: ['Shift Dress', 'Trousers', 'Blazer']
}, {
  id: 'jcrew',
  name: 'J.Crew',
  items: ['Wrap Dress', 'Jeans', 'Cardigan']
}, {
  id: 'banana',
  name: 'Banana Republic',
  items: ['Midi Dress', 'Slacks', 'Silk Shirt']
}, {
  id: 'loft',
  name: 'Loft',
  items: ['Floral Dress', 'Chinos', 'Sweater']
}, {
  id: 'talbots',
  name: 'Talbots',
  items: ['Sheath Dress', 'Skirt', 'Jacket']
}, {
  id: 'boden',
  name: 'Boden',
  items: ['Jersey Dress', 'Tunic', 'Coat']
}];
export function BrandSelectionStep({
  onNext,
  onBack
}: BrandSelectionStepProps) {
  const [selectedBrand, setSelectedBrand] = useState<string | null>(null);
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const handleSelect = (brandId: string, item: string) => {
    setSelectedBrand(brandId);
    setSelectedItem(item);
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="max-w-4xl mx-auto" data-id="element-206">
      <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-207">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-primary mb-6 text-center" data-id="element-208">
          Choose Your Brand & Item
        </h2>

        {/* Search Bar */}
        <div className="relative max-w-md mx-auto mb-8" data-id="element-209">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-210" />
          <input type="text" placeholder="Search brands (e.g. Madewell, Everlane...)" className="w-full pl-10 pr-4 py-3 rounded-full border border-gray-200 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-all" data-id="element-211" />
        </div>

        {/* Item Type Tabs */}
        <div className="flex justify-center space-x-2 mb-8 overflow-x-auto pb-2" data-id="element-212">
          {['Dresses', 'Tops', 'Pants', 'Skirts', 'Outerwear'].map((type, i) => <button key={type} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${i === 0 ? 'bg-text-primary text-white' : 'bg-gray-100 text-text-muted hover:bg-gray-200'}`} data-id="element-213">
                {type}
              </button>)}
        </div>

        {/* Brands Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-214">
          {brands.map(brand => <div key={brand.id} className={`border rounded-xl p-5 transition-all cursor-pointer ${selectedBrand === brand.id ? 'border-accent ring-1 ring-accent bg-accent/5' : 'border-gray-100 hover:border-accent/50 hover:shadow-md'}`} data-id="element-215">
              <h3 className="font-bold text-lg text-text-primary mb-3" data-id="element-216">
                {brand.name}
              </h3>
              <div className="space-y-2" data-id="element-217">
                {brand.items.map(item => <div key={item} onClick={() => handleSelect(brand.id, item)} className={`text-sm px-3 py-2 rounded-md flex justify-between items-center transition-colors ${selectedBrand === brand.id && selectedItem === item ? 'bg-accent text-white' : 'bg-white border border-gray-100 text-text-muted hover:border-accent/30'}`} data-id="element-218">
                    <span data-id="element-219">{item}</span>
                    {selectedBrand === brand.id && selectedItem === item && <span className="text-xs bg-white/20 px-2 py-0.5 rounded" data-id="element-220">
                        Selected
                      </span>}
                  </div>)}
              </div>
            </div>)}
        </div>

        <div className="flex justify-between pt-4 border-t border-gray-100" data-id="element-221">
          <Button variant="secondary" onClick={onBack} className="flex items-center gap-2" data-id="element-222">
            <ArrowLeft className="w-4 h-4" data-id="element-223" /> Back
          </Button>
          <Button onClick={() => onNext({
          brand: selectedBrand,
          item: selectedItem
        })} disabled={!selectedBrand || !selectedItem} data-id="element-224">
            See My Fit
          </Button>
        </div>
      </div>
    </motion.div>;
}